import React from 'react'
import PropTypes from 'prop-types'

const LoginContentSlot = ({ placeholders: { contents = []}, ...props }) =>
  <div>
    {
      React.Children.map(contents,
        element => React.cloneElement(element, { ...props }))
    }
  </div>

LoginContentSlot.propTypes = {
  placeholders: PropTypes.shape({
    contents: PropTypes.array
  })
}

LoginContentSlot.type = 'LoginContentSlot'

export default LoginContentSlot
